const owner = {
  name: 'WAOCON'
};

export default owner;
